import './style.css';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import DayMonthYearSelection from './DayMonthYearSelection';

import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const { RangePicker, MonthPicker, WeekPicker } = DatePicker;

dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const SelectionComponent = (props) => {
  const [, setPayload] = useState({});
  const [selectionWidget, setSelectionWidget] = useState(props.selectionWidget || {});
  const [mode, setMode] = useState(['month', 'month']);
  const [isOpen, setIsOpen] = useState(false);
  const [monthValue, setMonthValue] = useState(dayjs());
  const [year, setYear] = useState(dayjs());
  const [week, setWeek] = useState(dayjs().startOf('week'));
  const [selectedRange, setSelectedRange] = useState(null);
  const [dateRangeValue, setDateRangeValue] = useState({
    startDate: dayjs().subtract(30, 'days').utc().format('YYYY-MM-DD HH:mm:ss'),
    endDate: dayjs().utc().format('YYYY-MM-DD HH:mm:ss')
  });

  useEffect(() => {
    setSelectionWidget(props.selectionWidget);
    setMonthValue(dayjs());
  }, [props.selectionWidget]);

  const onYearPicker = (year) => {
    if (!selectionWidget.payload) return;
    const payload = {};
    Object.keys(selectionWidget.payload).forEach((param, index) => {
      const item = selectionWidget.payload[param];
      if (index === 0) {
        payload[param] = dayjs(year).startOf('year').utc().format(item.format);
      } else if (index === 1) {
        payload[param] = dayjs(year).endOf('year').utc().format(item.format);
      }
      if (param === 'year') {
        payload[param] = dayjs(year).utc().format('YYYY');
      }
    });
    setPayload(payload);
    props.selectionpayload(payload);
  };

  const onDataPickerChange = (value, dateString) => {
    if (!selectionWidget.payload) return;
    const payload = {};

    const inputDate = dayjs(dateString);
    const now = dayjs();
    Object.keys(selectionWidget.payload).forEach((param) => {
      const item = selectionWidget.payload[param];

      if (item.add) {
        const { value, key } = item.add;
        payload[param] = dayjs(dateString).utc().add(value, key).format(item.format);
      } else if (item.subtract) {
        const { value, key } = item.subtract;
        payload[param] = dayjs(dateString).utc().subtract(value, key).format(item.format);
      } else {
        if (param === 'startDate') {
          payload['startDate'] = dayjs(dateString).startOf('day').utc().format(item.format);
        } else if (param === 'endDate') {
          if (inputDate.month() === now.month() &&
            inputDate.year() === now.year() &&
            selectionWidget.payload.isConsiderWholeDay === false) {
            payload['endDate'] = dayjs(dateString).utc().format(item.format);
          } else {
            payload['endDate'] = dayjs(dateString).endOf('day').utc().format(item.format);
          }
        }
      }
      if (param === 'Date') {
        payload[param] = dayjs(dateString).utc().format('YYYY-MM-DD');
      }
    });
    setPayload(payload);
    props.selectionpayload(payload);
  };

  const onOk = (dates) => {
    if (!selectionWidget.payload) return;
    const payload = {};
    Object.keys(selectionWidget.payload).forEach((param, i) => {
      const item = selectionWidget.payload[param];
      payload[param] = dayjs(dates[i]).utc().format(item.format);
    });
    setPayload(payload);
    props.selectionpayload(payload);
  };

  const onMonthPickerChange = (date) => {
    if (!selectionWidget.payload) return;

    const now = dayjs();
    const inputDate = dayjs(date);
    const payload = {};

    Object.keys(selectionWidget.payload).forEach((param) => {
      const item = selectionWidget.payload[param];

      if (param === 'startDate') {
        payload[param] = inputDate.startOf('month').utc().format(item.format);
      } else if (param === 'endDate') {
        if (
          inputDate.month() === now.month() &&
          inputDate.year() === now.year() &&
          selectionWidget.payload.isConsiderWholeMonth === false
        ) {
          payload[param] = now.endOf('day').utc().format(item.format);
        } else {
          payload[param] = inputDate.endOf('month').utc().format(item.format);
        }
      } else if (param === 'month') {
        payload[param] = inputDate.utc().format(selectionWidget.payload.month);
      } else if (param === 'year') {
        payload[param] = inputDate.utc().format(selectionWidget.payload.year);
      }
    });

    setPayload(payload);
    setMonthValue(date);
    props.selectionpayload(payload);
  };

  const onWeakChange = (value) => {
    const startDate = dayjs(value).startOf('week').utc().format('YYYY-MM-DD HH:mm:ss');
    const endDate = dayjs(value).endOf('week').utc().format('YYYY-MM-DD HH:mm:ss');
    const payload = { startDate, endDate };
    setPayload(payload);
    setWeek(value);
    props.selectionpayload(payload);
  };

  const onRangePickerChange = (value, dateStrings) => {
    const [start, end] = dateStrings;
    const startDate = start ? dayjs(start).utc().format('YYYY-MM-DD HH:mm:ss') : '';
    const endDate = end ? dayjs(end).utc().format('YYYY-MM-DD HH:mm:ss') : '';
    const payload = { startDate, endDate };
    setPayload(payload);
    setDateRangeValue(value);
    props.selectionpayload(payload);
  };

  const onCalendarChange = (range) => {
    setSelectedRange(range);
  };

  const handlePanelChange = (dates, newMode) => {
    if (!selectionWidget.payload) {
      setMode(newMode.map(m => (m === 'date' ? 'month' : m)));
      return;
    }

    const [start, end] = dates;
    const payload = {};
    Object.keys(selectionWidget.payload).forEach((param, index) => {
      const item = selectionWidget.payload[param];
      if (index === 0) {
        payload[param] = dayjs(start).startOf('month').format(item.format);
      } else if (index === 1) {
        payload[param] = dayjs(end).add(1, 'month').startOf('month').format(item.format);
      }
    });
    setPayload(payload);
    props.selectionpayload(payload);
    setMode(newMode.map(m => (m === 'date' ? 'month' : m)));
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf('day');
  };

  const disabledRangeDate = (current) => {
    if (!selectedRange || !selectedRange[0]) {
      return current && current > dayjs().endOf('day');
    }
    const maxDate = dayjs(selectedRange[0]).add(31, 'days').endOf('day');
    return current.isBefore(selectedRange[0], 'day') || current.isAfter(maxDate) || current.isAfter(dayjs().endOf('day'));
  };

  const getPayload = (payload, currentTab) => {
    const tags = props.tags;
    const tagslistValue = { ...payload, tags };
    props.selectionpayload(tagslistValue, currentTab);
  };

  const {
    displayWidget,
    widget,
    displayDateFormat,
    displayTimeFormat,
    placeholder,
    format
  } = selectionWidget;

  const dateFormat = 'YYYY-MM-DD';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      marginBottom: '15px'
    }}>
      {displayWidget && widget === 'date-picker' && (
        <DatePicker//Completed
          onChange={onDataPickerChange}
          defaultValue={dayjs.utc()}
          placeholder={placeholder}
          disabledDate={disabledDate}
        />
      )}
      {displayWidget && widget === 'dateRange-picker' && (
        <RangePicker
          showTime={{ format: displayTimeFormat }}
          format={displayDateFormat}
          placeholder={placeholder}
          onChange={onRangePickerChange}
          onCalendarChange={onCalendarChange}
          onOk={onOk}
          defaultValue={[
            dayjs(dateRangeValue.startDate, dateFormat),
            dayjs(dateRangeValue.endDate, dateFormat)
          ]}
          disabledDate={disabledRangeDate}
          onOpenChange={() => {
            setSelectedRange(undefined);
          }}
          ranges={{
            'Reset Filter': [dayjs().subtract(30, 'days'), dayjs()]
          }}
        />
      )}
      {displayWidget && widget === 'month-picker' && (
        <MonthPicker//Completed
          className="picker"
          placeholder="Select month"
          value={monthValue}
          format={format}
          disabledDate={disabledDate}
          onChange={onMonthPickerChange}
        />
      )}
      {displayWidget && widget === 'monthRange-picker' && (
        <RangePicker
          placeholder={placeholder}
          format={format}
          mode={mode}
          onPanelChange={handlePanelChange}
        />
      )}
      {displayWidget && widget === 'year-picker' && (
        <DatePicker
          value={year}
          open={isOpen}
          mode="year"
          placeholder="Select Year"
          format="YYYY"
          onOpenChange={(status) => setIsOpen(status)}
          onPanelChange={(value) => {
            setIsOpen(false);
            setYear(value);
            onYearPicker(value);
          }}
        />
      )}
      {displayWidget && widget === 'weak-picker' && (
        <WeekPicker
          defaultValue={week}
          style={{ width: '200px' }}
          disabledDate={disabledDate}
          placeholder={placeholder}
          allowClear={false}
          onChange={onWeakChange}
        />
      )}
      {displayWidget && widget === 'dayMonthYear-picker' && (
        <DayMonthYearSelection //Completed
          selectionpayload={(payload, tab) => getPayload(payload, tab)}
          language={props.language}
          selectionWidget={props.selectionWidget}
        />
      )}
    </div>
  );
};

export default SelectionComponent;
